import { render, staticRenderFns } from "./Cgu.vue?vue&type=template&id=113ce677&"
import script from "./Cgu.vue?vue&type=script&lang=js&"
export * from "./Cgu.vue?vue&type=script&lang=js&"
import style0 from "./Cgu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports